import { useRouter } from 'next/router';

const usePathWithLocale = () => {
	const { locale, defaultLocale, asPath } = useRouter();
	const [path] = asPath.split(/[?#]/);
	return locale === defaultLocale ? path : `/${locale}${path !== '/' ? path : ''}`;
};

export default usePathWithLocale;
